import React from "react";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";


class CustomMatrixScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: false, matrices: [], sensors: [], page: 0, children: []};
    }

    componentDidMount() {
        API.POST("matrices/get", {id: this.props.id}, result => {
            if (result.success) {
                let matrix = result.result.matrix;
                this.setState(matrix);
                matrix.cameras.forEach(c => {
                    let id = "ticked" + c;
                    this.setState({[id]: true});
                });

                let children = result.result.children;
                this.setState({children});
                children.forEach(c => {
                    let id = "ticked_sa_" + c.customer_id;
                    this.setState({[id]: c.included});
                });
            } else {
                if (Util.getQuery("name")) {
                    this.setState({name: Util.getQuery("name")});
                }
                if (Util.getQuery("cameras")) {
                    try {
                        const raw = Util.getQuery("cameras");
                        const cameras = JSON.parse(raw);
                        cameras.forEach(c => {
                            let id = "ticked" + c;
                            this.setState({[id]: true});
                        });
                    } catch (e) {

                    }
                }
            }
        });
        API.POST("systems/list", {}, result => {
            if (result.success) {
                this.setState(result.result);
                this.setState({loaded: true});
            }
        });
    }

    render() {
        return (
            <div>
                <ActionBar title={"Custom Matrix Screen - " + (this.props.id == -1 ? "Add" : "Edit")}/>
                {this.renderTextAlert()}
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    padding: 16
                }}>
                    <div style={{flex: 1}}>
                        <div style={{display: "flex"}}>
                            <p>Matrix Name: </p>
                            <input style={{flex: 1}} className="vl-input" name="name" value={this.state.name}
                                   onChange={this.handleInputChange}/>
                            <VLButton title="Save" onClick={this.save} style={{marginLeft: 8}}/>
                        </div>
                        <h4>Select systems to include in this matrix</h4>
                        <div style={{display: "flex"}}>
                            {this.renderList()}
                            {this.renderSelected()}
                            {this.renderSubAccounts()}
                        </div>
                    </div>

                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    renderSelected = () => {
        let styleTd = {padding: 8};
        let ticked = this.state.sensors.filter(a => this.state["ticked" + a.sensor_id]);
        if (ticked.length == 0) {
            return <p style={{padding: 0, textAlign: "center", flex: 1}}>Choose systems on the left to add to this
                matrix</p>;
        }
        let rows = ticked.map(s => <tr>
            <td>{s.sensor_name}</td>
        </tr>);
        return <div style={{flex: 1, height: "calc(100vh - 200px)", overflowY: "auto"}}>
            <table style={{width: "100%"}} className="w3-table-all w3-table">
                <thead>
                <tr className="vl-theme">
                    <th style={styleTd}>Added Systems</th>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </table>
        </div>;
    };

    renderSubAccounts = () => {
        let styleTd = {padding: 8};

        let rows = this.state.children.map(c => {
            let id = "ticked_sa_" + c.customer_id;
            return <tr>
                <td>{c.name}</td>
                <td><input type="checkbox" name={id} checked={this.state[id]} onChange={this.handleInputChange}/></td>
            </tr>;
        });
        return <div style={{flex: 1}}>
            <table style={{width: "100%"}} className="w3-table-all w3-table">
                <thead>
                <tr className="vl-theme">
                    <th style={styleTd}>Share matrix with</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </table>
        </div>;
    };

    renderList = () => {
        let styleTd = {padding: 8};
        return (
            <div style={{flex: 1, height: "calc(100vh - 200px)", overflowY: "auto"}}>
                <table style={{width: "100%"}} className="w3-table-all w3-table">
                    <thead>
                    <tr className="vl-theme">
                        <th style={styleTd}>System</th>
                        <th style={styleTd}>Include</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.sensors.map(this.renderItem)}
                    </tbody>
                </table>
            </div>
        );
    };

    renderItem = (user) => {
        let styleTd = {padding: 8};
        let id = "ticked" + user.sensor_id;
        return (
            <tr>
                <td style={styleTd}>{user.sensor_name}</td>
                <td style={styleTd}>
                    <input type="checkbox" name={id} checked={this.state[id]} onChange={this.handleInputChange}/>
                </td>
            </tr>);
    };

    save = () => {
        let name = this.state.name.trim();
        if (name == "") {
            this.basicAlert("Please enter a name");
            return;
        }
        let cameras = [];
        this.state.sensors.forEach(a => {
            let id = a.sensor_id;
            if (this.state["ticked" + id]) {
                cameras.push(id);
            }
        });
        cameras = JSON.stringify(cameras);

        let children = [];
        this.state.children.forEach(a => {
            let id = a.customer_id;
            if (this.state["ticked_sa_" + id]) {
                children.push(id);
            }
        });
        children = JSON.stringify(children);

        let onDone = (result) => {
            if (result.success) {
                this.basicAlert("Your changes have been saved", Util.goBack);
            } else {
                this.basicAlert(result.error);
            }
        };

        if (this.props.id == -1) {
            //add new
            API.POST("matrices/add", {name: name, cameras, children}, onDone);
        } else {
            //edit existing
            API.POST("matrices/edit", {id: this.props.id, name, cameras, children}, onDone);
        }
    };

}

export default CustomMatrixScreen;
